<ng-template #content role="document" let-modal>
  <div class="modal-header p-3 border-1">
    <h5 class="modal-title mt-0">Late Cancellation Notice</h5>
    <button type="button" class="btn-close" aria-hidden="true" (click)="modal.dismiss('Cross click')"></button>
  </div>

  <div class="modal-body">
    <h4 class="mb-3">Would you like to refund the session?</h4>
    Sessions cancelled within 24 hours of the session start time do not require a refund but it is up to the trainer's discretion.
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="onConfirm(modal, false)">No Refund</button>
    <button type="submit" class="btn btn-primary" (click)="onConfirm(modal, true);">Refund</button>
  </div>
</ng-template>
